import React from 'react'
import { motion } from 'framer-motion'
import SVG from 'react-inlinesvg'
import { Dialog } from '@bhvr/web-design-system'

import warning from '../../assets/icons/warning.svg'
import warningOutline from '../../assets/icons/warning-outline.svg'
import close from '../../assets/icons/close.svg'

export const ErrorDialog = props => {
  return (
    <Dialog
      id="errorDialog"
      className={`${props.className} open`}
      closeIconClass="dialog-icon-close block text-black w-6 h-6"
      mainIconClass="dialog-icon-main block text-inherit w-10 h-10 mr-3"
      mainIcon={warning}
      closeIcon={close}
    >
      <h4 className="dialog-title text-sm font-bold">{props.modalTitle}</h4>
      <p className="dialog-text mb-0">{props.modalMessage}</p>
    </Dialog>
  )
}

export const ErrorHandle = props => {
/*   const toggleError = e => {
    document.getElementById('errorDialog').classList.add('open')
  } */

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.25,
      }}
      className="input-icon absolute right-0 bottom-[19px] m-0 text-red"
      data-dialog={props.target}
      //onClick={toggleError}
    >
      <SVG
        onError={(error) => console.log(error.message)}
        cacheRequests={true}
        src={warningOutline}
        title="error"
        className="input-icon-error pointer-events-none block h-5 w-5 text-red"
      />
    </motion.span>
  )
}
